module.exports = __webpack_public_path__ + "img/works_kbstar_btm_off.0ee002a3.jpg";